__webpack_require__.S = {};
const initPromises = {};
const initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	let initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	const scope = __webpack_require__.S[name];
	const warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	const uniqueName = "student-experience-v4-app";
	const register = (name, version, factory, eager) => {
		const versions = scope[name] = scope[name] || {};
		const activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	const initExternal = (id) => {
		const handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			const module = __webpack_require__(id);
			if(!module) return;
			const initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			const initResult = initFn(module);
			if(initResult?.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	const promises = [];
	switch(name) {
		case "default": {
			register("@emotion/react", "11.14.0", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(4158), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(54158))))));
			register("@emotion/styled", "11.14.1", () => (Promise.all([__webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(1479)]).then(() => (() => (__webpack_require__(71479))))));
			register("@mui/material", "6.5.0", () => (Promise.all([__webpack_require__.e(581), __webpack_require__.e(1848), __webpack_require__.e(7923), __webpack_require__.e(3168), __webpack_require__.e(6071), __webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(4646), __webpack_require__.e(6672), __webpack_require__.e(1020)]).then(() => (() => (__webpack_require__(46071))))));
			register("pvs-design-icons", "1.7.0", () => (Promise.all([__webpack_require__.e(7923), __webpack_require__.e(5759), __webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(4646), __webpack_require__.e(68)]).then(() => (() => (__webpack_require__(55759))))));
			register("pvs-design-system", "4.11.1", () => (Promise.all([__webpack_require__.e(581), __webpack_require__.e(1848), __webpack_require__.e(7923), __webpack_require__.e(3168), __webpack_require__.e(5353), __webpack_require__.e(2648), __webpack_require__.e(4914), __webpack_require__.e(1985), __webpack_require__.e(4204), __webpack_require__.e(4646), __webpack_require__.e(6672), __webpack_require__.e(5817), __webpack_require__.e(4748)]).then(() => (() => (__webpack_require__(62648))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(4914)]).then(() => (() => (__webpack_require__(40961))))));
			register("react-redux", "8.0.5", () => (Promise.all([__webpack_require__.e(4832), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(34832))))));
			register("react-router-dom", "7.18.2", () => (Promise.all([__webpack_require__.e(8515), __webpack_require__.e(4914), __webpack_require__.e(6672)]).then(() => (() => (__webpack_require__(48515))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};